"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  today: {
    text: 'Today',
    start: function start() {
      return (0, _moment["default"])();
    },
    end: function end() {
      return (0, _moment["default"])();
    },
    timeInterval: 'day'
  },
  yesterday: {
    text: 'Yesterday',
    start: function start() {
      return (0, _moment["default"])().subtract(1, 'day');
    },
    end: function end() {
      return (0, _moment["default"])().subtract(1, 'day');
    },
    timeInterval: 'day'
  },
  thisWeek: {
    text: 'This week',
    start: function start() {
      return (0, _moment["default"])().startOf('week');
    },
    end: function end() {
      return (0, _moment["default"])().endOf('week');
    },
    timeInterval: 'week'
  },
  lastWeek: {
    text: 'Last week',
    start: function start() {
      return (0, _moment["default"])().subtract(1, 'week').startOf('week');
    },
    end: function end() {
      return (0, _moment["default"])().subtract(1, 'week').endOf('week');
    },
    timeInterval: 'week'
  },
  thisMonth: {
    text: 'This month',
    start: function start() {
      return (0, _moment["default"])().startOf('month');
    },
    end: function end() {
      return (0, _moment["default"])().endOf('month');
    },
    timeInterval: 'month'
  },
  lastMonth: {
    text: 'Last month',
    start: function start() {
      return (0, _moment["default"])().subtract(1, 'month').startOf('month');
    },
    end: function end() {
      return (0, _moment["default"])().subtract(1, 'month').endOf('month');
    },
    timeInterval: 'month'
  },
  lastYear: {
    text: 'Last year',
    start: function start() {
      return (0, _moment["default"])().subtract(1, 'year');
    },
    end: function end() {
      return (0, _moment["default"])();
    },
    timeInterval: 'year'
  },
  lastTwoYears: {
    text: 'Last Two years',
    start: function start() {
      return (0, _moment["default"])().subtract(2, 'year');
    },
    end: function end() {
      return (0, _moment["default"])();
    },
    timeInterval: 'year'
  },
  all: {
    text: 'All',
    start: function start() {
      return (0, _moment["default"])('2015-01-01');
    },
    end: function end() {
      return (0, _moment["default"])();
    },
    timeInterval: 'all'
  }
};
exports["default"] = _default;

//# sourceMappingURL=FixedRanges.js.map